<template>
  <!-- Миниатюра снимка. Разметка та же, что была у vue-expandable-image
       (`.expandable-image > img`): на неё опираются стили галерей по всему
       приложению, и менять их из-за смены компонента незачем. -->
  <div class="expandable-image" :class="{ 'expandable-image--pending': loading || failed }" role="button" tabindex="0" aria-label="Открыть изображение" @click="expand" @keydown.enter.prevent="expand" @keydown.space.prevent="expand">
    <i v-if="!loading && !failed" class="expand-button">
      <svg viewBox="0 0 24 24" width="24" height="24">
        <path fill="currentColor" d="M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z"/>
      </svg>
    </i>
    <img :key="$attrs.src" v-bind="$attrs" v-on="$listeners" :style="{ opacity: loading || failed ? 0 : 1 }" @load="loaded" @error="unavailable">
    <div v-if="loading || failed" class="image-placeholder" :class="{ 'image-placeholder--loading': loading }" role="status">
      <template v-if="failed"><v-icon>mdi-image-off-outline</v-icon><span>Изображение недоступно</span></template>
      <span v-else class="sr-only">Загрузка изображения</span>
    </div>
  </div>
</template>

<script>
import { collectImageGroup, openImageViewer } from '@/shared/lib/imageViewer'

export default {
  name: 'ExpandableImage',
  inheritAttrs: false,
  props: {
    // Проп остался от прежней библиотеки — его передают в двух десятках мест.
    // Клик по фону закрывает просмотр в любом случае: так ведут себя все
    // подобные окна, и отдельного «не закрывать» здесь никто не ждал.
    closeOnBackgroundClick: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({ loading: true, failed: false }),
  watch: { '$attrs.src'() { this.loading = true; this.failed = false } },
  methods: {
    loaded() { this.loading = false; this.failed = false },
    unavailable() { this.loading = false; this.failed = true },
    expand () {
      const group = collectImageGroup(this.$el)

      openImageViewer(group.items, group.index)
    }
  }
}
</script>

<style scoped>
.expandable-image {
  position: relative;
  cursor: zoom-in;
}

.expandable-image > img {
  display: block;
  width: 100%;
}

/* Значок «развернуть» показываем при наведении: на плитке из десятка
   снимков постоянные иконки перекрывают сами фотографии. */
.expand-button {
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  padding: 2px;
  border-radius: 4px;
  background: rgba(20, 27, 38, 0.55);
  color: #fff;
  opacity: 0;
  transition: opacity 0.15s ease;
  pointer-events: none;
}

.expandable-image:hover .expand-button {
  opacity: 1;
}
</style>

<style scoped>
.expandable-image--pending { min-height: 100px; }
.image-placeholder { position: absolute; inset: 0; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 8px; padding: 8px; background: var(--sts-surface-2); color: var(--sts-text-muted); border: 1px solid var(--sts-line); border-radius: 4px; text-align: center; }
.image-placeholder span { font-size: 12px; line-height: 1.3; }
.image-placeholder .v-icon { color: inherit; }
.image-placeholder--loading { animation: image-loading 1.4s ease-in-out infinite; }
.sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0,0,0,0); }
.expandable-image:focus-visible { outline: 2px solid var(--sts-accent); outline-offset: 2px; }
@keyframes image-loading { 50% { opacity: .45; } }
@media(prefers-reduced-motion: reduce) { .image-placeholder--loading { animation: none; } }
</style>
